import { useEffect, useState } from 'react';
import { ClaimRequest } from '../../domain/entities';
import { DuplicatedInvoiceRepository } from '../../infraestructure/repositories/invoice/DuplicatedInvoiceRepository';

const invoiceRepository = new DuplicatedInvoiceRepository();

export const useInvoiceRelatedClaimRequests = (
    taxIdNumber: string | undefined,
    number: string | undefined,
    date: Date | null | undefined
) => {
    const [claimRequests, setClaimRequests] = useState<ClaimRequest[]>([]);
    const [loading, setLoading] = useState(false);

    // Use a stable primitive so object identity changes on re-renders don't fire extra requests.
    // Invalid Date (getTime() === NaN) is coerced to null to skip the fetch safely.
    const dateTime = date instanceof Date && !isNaN(date.getTime()) ? date.getTime() : null;

    useEffect(() => {
        if (taxIdNumber == null || number == null || dateTime == null) {
            setClaimRequests([]);
            setLoading(false);
            return;
        }

        let cancelled = false;
        setLoading(true);

        invoiceRepository
            .findInvoiceRelatedClaimRequests(taxIdNumber, number, new Date(dateTime))
            .then((results) => {
                if (!cancelled) setClaimRequests(results);
            })
            .catch(() => {
                if (!cancelled) {
                    console.error('Error while fetching invoice related claim requests');
                    setClaimRequests([]);
                }
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [taxIdNumber, number, dateTime]);

    return { claimRequests, loading };
};

